module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "LearnSlider"
  }, [(_vm.content.text) ? _c('div', {
    staticClass: "LearnSlider-header t-small",
    domProps: {
      "innerHTML": _vm._s(_vm.content.text)
    }
  }) : _vm._e(), _vm._v(" "), _c('carousel', {
    ref: "carousel",
    staticClass: "LearnSlider-carousel",
    attrs: {
      "initial-index": _vm.goToIndex
    }
  }, _vm._l((_vm.content.options), function(item, index) {
    return _c('div', {
      staticClass: "LearnSlider-item",
      on: {
        "click": function($event) {
          _vm.handleItemClick(index)
        }
      }
    }, [_c(item.type, {
      tag: "component",
      attrs: {
        "image": item.image,
        "content": item,
        "disabled": index !== _vm.selectedIndex
      }
    })], 1)
  })), _vm._v(" "), (_vm.content.footer) ? _c('div', {
    staticClass: "LearnSlider-footer t-small",
    domProps: {
      "innerHTML": _vm._s(_vm.content.footer)
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-183d94e0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Learn/LearnSlider.vue
// module id = 819
// module chunks = 1